import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { AboutPageVM } from './AboutPageVM';
import './aboutPage.scss';
import { appConfig } from 'cd-eft/config/AppConfig';
import { formatDateShort } from 'cd-eft/utils/formatDate';
import { RTEComponent, RTDComponent } from '../RTE/RTE';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';
import { Input } from 'cd-eft/components/common/Input';
import Icon from '@mdi/react';
import { Table } from 'reactstrap';
import { Accordion } from '../Accordion';
import { Popup } from 'cd-eft/components/common/Popup';
import { htmlParser } from 'cd-eft/utils/stringUtilities';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import {
  mdiPlusCircle,
  mdiTrashCanOutline,
  mdiPencil,
  mdiMinus,
  mdiPlus
} from '@mdi/js';
interface IReleaseNoteAdd {
  vm: AboutPageVM,
  mode?: 'add' | 'edit' | 'delete' | 'original' | 'deletePopup' | 'editPopup',
}

const ReleaseNote = observer(({ vm }: IReleaseNoteAdd) => {
  return (
    <>
      {vm.releaseNotes.map((item, index) => (
        <div className="usa-card__body " key={index}>
          <div className="release-note-header" tabIndex={0}>
            <div>{item.releaseVersion}</div>
            <div>{formatDateShort(item.releaseDate.replace(/-/g, '\/'))}</div>
            <div>
              <h3>{item.releaseTitle}
                &nbsp;&nbsp;<button className='usa-button--unstyled' onClick={() => vm.onClickEditReleaseNote(index)}> <Icon path={mdiPencil} size={1} /> Edit</button>
              </h3>
            </div>
          </div>
          <div tabIndex={0}>
            <div className="notes-description-card">{htmlParser(item.releaseDescription)}</div>
          </div>
        </div>
      ))}
    </>
  )
})

const AddReleaseNote = observer(({ vm }: IReleaseNoteAdd) => {
  const initialRTEString = useRef(vm.rteReleaseNoteDescription).current;
  return (
    <>
      <div className='release-version-date-inputs'>
        <Input
          className={vm.releaseNoteInputsValidation.releaseVersion.errorMessage ? 'usa-input--error release-version' : 'release-version'}
          idAndName='release-version'
          label='Release Number'
          wrapperClassName='release-version'
          valid={vm.releaseNoteInputsValidation.releaseVersion.valid}
          value={vm.releaseNumber}
          type='text'
          required={true}
          onChange={vm.onChangeReleaseNumber}
          // placeholder={'Format: '+ appConfig.releaseVersion}
          onBlur={vm.releaseNoteValidateInputs}
        />
        <Input
          className={vm.releaseNoteInputsValidation.releaseDate.errorMessage ? 'usa-input--error release-date' : 'release-date'}
          idAndName='release-date'
          label='Release Date'
          wrapperClassName='release-date'
          valid={vm.releaseNoteInputsValidation.releaseDate.valid}
          value={vm.releaseDate}
          type='date'
          required={true}
          onChange={vm.onChangeReleaseDate}
          onBlur={vm.releaseNoteValidateInputs}
        />
      </div>
      <Input
        className={vm.releaseNoteInputsValidation.title.errorMessage ? 'usa-input--error note-title' : 'note-title'}
        idAndName='note-title'
        label='Title'
        wrapperClassName='note-title'
        valid={vm.releaseNoteInputsValidation.title.valid}
        value={vm.addedReleaseNoteName}
        type='text'
        required={true}
        onChange={vm.onChangeAddedReleaseNoteName}
        onBlur={vm.releaseNoteValidateInputs}
      />
      <div data-testid='rte-container'>
        <label className={"usa-label rte-label"}>
          Description
        </label>
        <RTEComponent
          saveCallback={vm.rteTextCallBack}
          initialValue={initialRTEString}
          contentString={vm.rteReleaseNoteDescription}
          onBlur={vm.releaseNoteValidateInputs}
        />
      </div>
      <div className='buttons-group'>
        <button className='usa-button usa-button--outline' onClick={vm.handleReleaseNoteCancel}>Close</button>
        <button className='usa-button' onClick={vm.onClickSaveReleaseNote} disabled={vm.disableSaveButtonAddNote}>Save</button>
      </div>
      {vm.mode === 'editPopup' && <DeletePopup vm = {vm} mode={vm.mode}/>}
    </>
  )
})

const DeleteReleaseNote = observer(({ vm }: IReleaseNoteAdd) => {
  return (
    <div className='release-notes-delete-container'>
      {vm.releaseNotes.map((item, index) => {
        return (
          <Checkbox
            id={`${item.releaseId}-checkbox-${index}`}
            key={`${item.releaseId}-checkbox-${index}`}
            name={`${item.releaseId}-checkbox-${index}`}
            checked={vm.seletedDeletetReleaseNotes.includes(item.releaseId)}
            onChange={() => vm.onChangeCheckDeleteReleaseNotes(item.releaseId)}
            label={item.releaseTitle}
          />
        )
      })}

      <div className="del-button-container">
        <button
          className="usa-button usa-button--outline"
          onClick={() => vm.switchMode('delete')}
          aria-label="Cancel"
        >
          Close
        </button>
        {vm.seletedDeletetReleaseNotes.length ? (
          <button className="usa-button"
            onClick={() => vm.switchMode('deletePopup')}
            aria-label="Delete"
          >
            Delete
          </button>
        ) : null}
      </div>
      {vm.mode === 'deletePopup' && <DeletePopup vm = {vm} mode={vm.mode}/>}
    </div>
  )
})

const DeletePopup = observer(({ vm, mode }: IReleaseNoteAdd)=>{
  return(
    <div>
      {vm.seletedDeletetReleaseNotes.length ? (
        <div className={mode}>
          <Popup
            trigger={vm.mode === mode}
            setTrigger={() => vm.switchMode(mode!)}
            title="Delete Release Note?"
            handleCancel={() => vm.switchMode(mode!)}
            cancelText="Close"
            handleOK={vm.deleteReleaseNoteHandler}
            okText="Delete"
            loader={true}
          >
            {vm.seletedDeletetReleaseNotes.length === 1 ? (
              <p>Are you sure you want to delete this note?</p>
            ) : (
              <p>Are you sure you want to delete these notes?</p>
            )}
            <div className='glossary-delete-comment-wrraper'>
              <Table borderless>
                <tbody>
                  {vm.seletedDeletetReleaseNotes.map((id) => (
                    <tr key={`tr-${id}`}>
                      <th>Title</th>
                      {mode==='deletePopup' && <td>{vm.releaseNotesDictionary[id].releaseTitle}</td>}
                      {mode==='editPopup' && <td>{vm.addedReleaseNoteName}</td>}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Popup>
        </div>
      ) : null}
    </div>
  )
})

const AboutPageComponent = (props) => {
  const vm = useRef(new AboutPageVM()).current;
  useEffect(() => {
    vm.getReleaseNotes();
    vm.getRoadmap();
  }, []);
  return (
    <div className='release-notes-container'>
      {!props.adminContent ?
        (
          <div className="about-container">
            <h1 tabIndex={0}>About NETS</h1>
            <p className="about-description" tabIndex={0}>
              <b>The NRCS Engineering Tool Suite (NETS) </b> is a framework of engineering tools for field office staffs to plan and design commonly
              applied conservation practices. These tools will support planning, designing, and reporting for use as design documentation and final
              construction drawings.

            </p>

            <div className="roadmap">
              <h2 tabIndex={0}>
                <b>NETS Roadmap</b>
              </h2>
              <div className='blue-line bar'>
                <RTDComponent htmlString={vm.roadmapDescription} />
              </div>

            </div>

            <div className="roadmap">
              <h2 tabIndex={0} id="release_notes">
                <b>Release Notes</b>
              </h2>
              {vm.releaseNotes.length > 0
                ? vm.releaseNotes.map((item, index) => (
                  <div className="release-note" key={index + item.releaseTitle} >
                    <div className="release-note-header" tabIndex={0}>
                      <div>{item.releaseVersion}</div>
                      <div>{formatDateShort(item.releaseDate.replace(/-/g, '\/'))}</div>
                      <div>
                        <h3>{item.releaseTitle}</h3>
                      </div>
                    </div>
                    <div tabIndex={0}>
                      <div className="notes-description">{htmlParser(item.releaseDescription)}</div>
                    </div>
                  </div>
                ))
                : null}
            </div>
          </div>) :
        <Accordion className="p-0 accordion-wrapper accordion-release-notes" headers={['Release Notes']} >
          <div className='sub-container'>
            <div className="action-menu-wrapper about-page-wrapper">
              {vm.mode === 'original' && <button className='usa-button usa-button--outline  add-card add-notes' aria-label='add release notes' onClick={() => vm.switchMode('add')}><Icon path={mdiPlusCircle} size={1} />  Add</button>}
              {vm.mode !=='add' && <button className='usa-button usa-button--unstyled delete-notes' aria-label='delete release notes' onClick={() => vm.switchMode('delete')}><Icon path={mdiTrashCanOutline} size={1} />  Delete </button>}
            </div>
            <div className="notes-container">
              {vm.loader && <Loader/>}
              {vm.releaseNotes.length > 0 && !props.buttomContainer && vm.mode === 'original' && <ReleaseNote vm={vm} />}
              {!props.buttomContainer && (vm.mode === 'add' || vm.mode === 'edit' || vm.mode === 'editPopup') && <AddReleaseNote vm={vm} />}
              {!props.buttomContainer && (vm.mode === 'delete' || vm.mode === 'deletePopup') && <DeleteReleaseNote vm={vm} />}

            </div>
          </div>
        </Accordion>}
    </div>
  );
};



export const AboutPage = observer(AboutPageComponent);
